import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const withStyles = styles => Component => {
  const ComponentWithStyles = props => {
    const classes = makeStyles(styles)();
    return <Component classes={classes} {...props} />;
  };

  const componentName = Component.displayName || Component.name || "Unknown";
  ComponentWithStyles.displayName = `WithStyles(${componentName})`;

  return ComponentWithStyles;
};

export default withStyles;
